export default "__VITE_ASSET__DLxFmlJs__"